(function () {
  var TARGET_IDS = [
    'slider-logo_list_Cd9HbN',
    'slider-collection_list_y8Bwtr',
    'slider-collection_list_fFRjAV'
  ];

  function setup(sliderId) {
    var slider = document.getElementById(sliderId);
    if (!slider) return;

    var grid = slider.querySelector('.slider__grid');
    if (!grid || grid.classList.contains('auto-scroll-track')) return;

    // Clone all existing items once so the track can loop seamlessly at -50%.
    var originalItems = Array.prototype.slice.call(grid.children);
    originalItems.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      // Avoid duplicate tab-stops / duplicate IDs from cloned content.
      clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      clone.querySelectorAll('a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      grid.appendChild(clone);
    });

    grid.classList.add('auto-scroll-track');

    // Hide manual prev/next arrows now that the row scrolls on its own.
    var wrapper = slider.closest('carousel-slider');
    if (wrapper) {
      var nav = wrapper.querySelector('.slider-nav');
      if (nav) nav.style.display = 'none';
    }
  }

  function init() {
    TARGET_IDS.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
